/**
 * @generated SignedSource<<971fb999a033f47115d7aad5cf581c93>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PhotoType = "APPEAL" | "PROFILE" | "VERIFICATION" | "%future added value";
export type CreatePhotoInput = {
  clientMutationId?: string | null | undefined;
  photo: PhotoInput;
};
export type PhotoInput = {
  description?: string | null | undefined;
  sequence?: number | null | undefined;
  storageObjectId: any;
  type: PhotoType;
};
export type useProfilePhotosCreatePhotoMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CreatePhotoInput;
};
export type useProfilePhotosCreatePhotoMutation$data = {
  readonly createPhoto: {
    readonly photoEdge: {
      readonly cursor: any | null | undefined;
      readonly node: {
        readonly description: string | null | undefined;
        readonly id: string;
        readonly rowId: any;
        readonly sequence: number;
        readonly storageObject: {
          readonly bucket: string | null | undefined;
          readonly key: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useProfilePhotosCreatePhotoMutation = {
  response: useProfilePhotosCreatePhotoMutation$data;
  variables: useProfilePhotosCreatePhotoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "connections"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": [
      "SEQUENCE_ASC"
    ]
  }
],
v3 = {
  "alias": null,
  "args": (v2/*:: as any*/),
  "concreteType": "PhotoEdge",
  "kind": "LinkedField",
  "name": "photoEdge",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Photo",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sequence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "StorageObject",
          "kind": "LinkedField",
          "name": "storageObject",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "bucket",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "key",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "photoEdge(orderBy:[\"SEQUENCE_ASC\"])"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useProfilePhotosCreatePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreatePhotoPayload",
        "kind": "LinkedField",
        "name": "createPhoto",
        "plural": false,
        "selections": [
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useProfilePhotosCreatePhotoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "CreatePhotoPayload",
        "kind": "LinkedField",
        "name": "createPhoto",
        "plural": false,
        "selections": [
          (v3/*:: as any*/),
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "filters": null,
            "handle": "appendEdge",
            "key": "",
            "kind": "LinkedHandle",
            "name": "photoEdge",
            "handleArgs": [
              {
                "kind": "Variable",
                "name": "connections",
                "variableName": "connections"
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "14a360217882f30f940fc786e7636f5b",
    "id": null,
    "metadata": {},
    "name": "useProfilePhotosCreatePhotoMutation",
    "operationKind": "mutation",
    "text": "mutation useProfilePhotosCreatePhotoMutation(\n  $input: CreatePhotoInput!\n) {\n  createPhoto(input: $input) {\n    photoEdge(orderBy: [SEQUENCE_ASC]) {\n      cursor\n      node {\n        description\n        id\n        rowId\n        sequence\n        storageObject {\n          bucket\n          key\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "561c133289fc849ff552ba53183e914e";

export default node;
